export default __webpack_public_path__ + "static/media/468.55c92612.png";